import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit {

  showContent: boolean = false;
  urlDest: string;
  urlDestForRedirect: string;
  idRessource: string;
  IDO: string;

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.urlDest = params['urlDest'];
      this.urlDestForRedirect = params['urlDest'];
      this.idRessource = params['idRessource'];
      this.IDO = params['IDO'];

      if (this.urlDest) {
        this.showContent = true;
         //this.urlDest = decodeURIComponent(this.urlDest).replace('\:','&#58;'); Ajouter plusieurs fois pour remplcer le '/:' en cas de paramètre.
        this.urlDest = decodeURIComponent(this.urlDest).replace("\:","&#58;");
        this.urlDest = decodeURIComponent(this.urlDest).replace("\:","&#58;");
        this.urlDest = decodeURIComponent(this.urlDest).replace("\:","&#58;");
      }
      else {
        console.log('Le paramètre urlDest n\'est pas présent');

        this.router.navigate(['error'], { queryParamsHandling: 'preserve' });
      }
    });
  }

  ngOnInit() {
  }

  sortirDuGar() {
    // this.router.navigate(['sortir'], { queryParamsHandling: 'preserve' });
    window.location.href = '/sortir?urlDest=' + encodeURIComponent(this.urlDestForRedirect) + '&idRessource=' + this.idRessource + '&IDO=' + this.IDO;
  }

  resterSurleGar() {
    window.close();
  }
}
